import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/services/auth.service';
import { TranslationExtenderService } from './core/services/translation-extender.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('gaulbridge-admin-frontend');

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private translationExtender: TranslationExtenderService
  ) {
    this.translate.addLangs(['en', 'es', 'fr']);
    this.translate.setDefaultLang('en');

    const savedLang = localStorage.getItem('last_updated_language');
    const lang = savedLang && ['en', 'es', 'fr'].includes(savedLang) ? savedLang : 'en';
    this.translate.use(lang);

    // Kickstart CSRF + translations in parallel at bootstrap if authenticated
    if (this.authService.isAuthenticated()) {
      this.authService.ensureCsrfReady();
      this.translationExtender.load(lang).subscribe();
    }
  }
}
